import React, { useState } from "react";
import { MailPlus } from "lucide-react";
import InvitationModal from "../../components/modals/InvitationModal";
import ListInvitations from "../../admin/components/invitations/ListInvitations";
import Alumnis from "../../admin/components/alumnis/Alumnis";

export default function AlumniTab() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<"all" | "pending">("all");

  return (
    <section className="p-10 flex flex-col gap-6">
      <div className="py-8">
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2 transition-all duration-200"
        >
          <MailPlus className="h-5 w-5" />
          Invite User
        </button>
        <InvitationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>

      <div className="flex gap-4 border-b border-gray-200">
        <button
          onClick={() => setActiveTab("all")}
          className={`pb-2 px-1 font-medium transition-colors ${
            activeTab === "all"
              ? "text-orange-600 border-b-2 border-orange-600"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          All alumnis
        </button>
        <button
          onClick={() => setActiveTab("pending")}
          className={`pb-2 px-1 font-medium transition-colors ${
            activeTab === "pending"
              ? "text-orange-600 border-b-2 border-orange-600"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          Pending invitations
        </button>
      </div>

      <section>
        {activeTab === "pending" ? <ListInvitations /> : <Alumnis />}
      </section>
    </section>
  );
}
